import { NotificationService } from '../shared/notification.service';
import { StockService } from './../stock-mapping/stock.service';
import { StockData, StockInfo  } from '../models/stock';
import { Component, HostListener, OnInit, TemplateRef } from '@angular/core';
import { PriceNames  } from '../models/pricelist';
import * as XLSX from 'xlsx';
import { resultType } from '../shared/modal-content/modal-content.component'; 
import { AuthService } from '../auth.service';



@Component({
  selector: 'app-stock-override',
  templateUrl: './stock-override.component.html',
  styleUrls: ['./stock-override.component.less']
})
export class StockOverrideComponent implements OnInit {

  pricelist: PriceNames;
  stockInfo: StockInfo[]=[];
  editCache: { [key: string]: { edit: boolean; data: StockData } } = {};
  overrideData: StockData[]=[];
  options: StockInfo[]=[];

  // msfid: number = 0;
  msfid: string[] = [];
  inputValue: string = "";
  color: string = '#117274';
  fileName:string = 'ExcelSheet.xlsx';
  info:string = 'To search for multiple classifications, seperate search with a space eg. 2656517 MICH 242767.'


  showSearch:boolean = false;
  brandClicked : boolean = false;
  genCodeClicked : boolean = false;
  isAddModalVisible:boolean = false;
  stockCodeClicked : boolean = false;
  isLoading: boolean = true;
  showNonActiveStock: boolean = false;

  overrideFilter: string = "";
  overrideFilterArray: string[] = ['brand', 'stock_code', 'description']
  pageSize: number = 30;
  itemSize: number = 20;

  priceIn: number = 0;
  marginType : number = 1; // 1 = retail less, 2 = cost plus, 3 = branch cost plus
  priceType : string = 'overRidePriceOnline'; 
  overrideMargin: number = 0;

  @HostListener("window:scroll", [])
    onScroll(): void {
    if ((window.innerHeight + window.scrollY) >= document.body.scrollHeight - (document.body.scrollHeight * 0.1)) {
            // you're at the bottom of the page
            this.pageSize += 15;
        }
    }
    resetTable(){
        this.pageSize = 30;
    }

  fnSortBrand = (a: StockData, b: StockData) => a.brand && b.brand ? a.brand.localeCompare(b.brand) : 0
  fnSortStockCode = (a: StockData, b: StockData) => a.stock_code && b.stock_code ? a.stock_code.localeCompare(b.stock_code) : 0
  fnSortDate = (a: StockData, b: StockData) => a.dateCreated && b.dateCreated ? a.dateCreated.toString().localeCompare(b.dateCreated.toString()) : 0
  fnSortDescription = (a: StockData, b: StockData) => a.description.localeCompare(b.description)

  constructor(private stockService: StockService, private notification: NotificationService, public authService: AuthService) { }

  ngOnInit(){
    this.isLoading = true;
    this.reloadData();
    this.getData();

    this.notification.ShowAlert({type: resultType.Information, 
                                 title: "Stock Override", 
                                 htmlMessage: 'Add custom pricing that will overrule all other pricing <br>'+
                                              'If you need to move aging stock or protect scarce stock, this is where you can do it. <br>'+
                                              '<span class="text-style">To prevent stock being displayed on a price list set its price to zero <span >(0)</span></span> <br>', 
                                 btnText: "OK", 
                                 maskClosable: false, 
                                 autoCloseInMilliseconds: 12000})
  }

  reloadData(){
    this.pricelist= new PriceNames;
    this.overrideData = [];
    this.stockInfo= [];
    this.options = [];
    this.msfid = [];

  }

  getData(){
    this.stockService.getStock().subscribe((res:any) => {
        this.pricelist = res.pricedata as PriceNames;
        this.overrideData = res.override_Data as StockData[];
        this.stockInfo = res.stock_info as StockInfo[];
        this.stockInfo.map(item => item.descriptionFull = `${item.description} ${item.brand} ${item.stockcode}`);
        this.tempStockInfo = this.stockInfo.slice(0,this.itemSize);
        this.isLoading = false;
        this.updateEditCache();
      },
      error => {
        this.notification.handleError(error);
      }
    )
  }

  onClickAddNewRule() {
    this.isAddModalVisible = true;
    this.inputValue = "";
    this.msfid = [];
  }

  tempStockInfo: readonly StockInfo[] = [];

  overrideAddTable : StockInfo[] = [];

  addOverRideStock(){
    let missingStockCodeArray: string[] = []
    let duplicateArray: string[] = []

    // Find missing and duplicate stock codes

    missingStockCodeArray = this.msfid.filter(item => !this.stockInfo.map(val => val.stockcode).includes(item));
    duplicateArray = this.msfid.filter(item => this.overrideAddTable.map(val => val.stockcode).includes(item));

    this.overrideAddTable = [...this.overrideAddTable, ...this.stockInfo.filter(item => this.msfid.includes(item.stockcode) && !duplicateArray.includes(item.stockcode))];

    if(missingStockCodeArray.length > 0 || duplicateArray.length > 0){
      const missingString = missingStockCodeArray.length > 0 ? 'The following stock code(s) were not identified in the system: <br> ' + missingStockCodeArray.join('<br>') : '';
      const duplicateString = duplicateArray.length > 0 ? 'The following stock code(s) have already been added to the list: <br> ' + duplicateArray.join('<br>') : '';
      this.notification.ShowAlert({type: resultType.Warning, 
        title: "Stock Code(s) Errors",
        htmlMessage: missingString + '<br>' + 
        duplicateString,
        maskClosable: true});
    }
    this.msfid = [];
  }

  removeRule(item:StockData){
    this.stockService.removeItem(item).subscribe(res =>{
        this.notification.showSuccess("successfully Removed " + item.description);
        this.overrideData = this.overrideData.filter(val => val.overindex !== item.overindex);
        this.overrideData = [...this.overrideData];
      },
      error => {
        this.notification.handleError(error);
      })
  }

  addRule(){
    this.isLoading = true;

    let overrideArray = this.overrideAddTable.map(item => ({
      msfid: item.msfid,

      priceinternal: item.priceinternal?.toString(),
      pricedefault:  item.pricedefault?.toString(),
      pricewholesale:  item.pricewholesale?.toString(),
      priceretail:  item.priceinternal?.toString(),
      priceonline:  item.priceinternal?.toString(),
      priceclearout:  item.priceclearout?.toString(),
      pricecustom1:  item.pricecustom1?.toString(),
      pricecustom2:  item.pricecustom2?.toString(),
      pricecustom3:  item.pricecustom3?.toString(),
      pricecustom4:  item.pricecustom4?.toString(),

      overRidePriceOnline: item.overRidePriceOnline?.toString(),
      overRidePriceRetail: item.overRidePriceRetail?.toString(),
      overRidePriceDefault: item.overRidePriceDefault?.toString(),
      overRidePriceWholesale: item.overRidePriceWholesale?.toString(),
      overRidePriceInternal: item.overRidePriceInternal?.toString(),
      overRidePriceClearout: item.overRidePriceClearout?.toString(),
      overRidePriceCustom1: item.overRidePriceCustom1?.toString(),
      overRidePriceCustom2: item.overRidePriceCustom2?.toString(),
      overRidePriceCustom3: item.overRidePriceCustom3?.toString(),
      overRidePriceCustom4: item.overRidePriceCustom4?.toString(),
     }));

    this.stockService.addNewRule(overrideArray).subscribe(res =>{

      let newOverrideArray = res as unknown as StockData[];

      this.overrideData = this.overrideData.filter(item => newOverrideArray.every(override => override.stock_code !== item.stock_code));
      // this.overrideData.push(res[0]);
      this.overrideData = [...this.overrideData, ...res as unknown as StockData[]];

      this.isAddModalVisible = false;
      this.isLoading = false;
      this.updateEditCache();

      this.inputValue = "";
      this.msfid = [];
      this.overrideAddTable = [];
      this.overrideMargin = 0;

      this.notification.showSuccess("Rules Added Successfully");
    },
    error =>{
      this.notification.handleError(error);
      this.isLoading = false;
    })
  }

  exportexcel(){
    let element = document.getElementById('tbl');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element,{raw:true});
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, this.fileName);
  }

  startEdit(id: number): void {
    this.editCache[id].edit = true;
  }

  saveEdit(id: number): void {
    const index = this.overrideData.findIndex(item => item.overindex === id);

    this.stockService.editItem(this.editCache[id].data).subscribe({next : (res) =>{
      Object.assign(this.overrideData[index], this.editCache[id].data);
      this.editCache[id].edit = false;
    },
    error: (error) => {
      this.notification.handleError(error);
    },
    complete: () => {
      this.notification.showSuccess("Rule Updated Successfully");
    }
  });
  }

  cancelEdit(id: number): void {
    const index = this.overrideData.findIndex(item => item.overindex === id);
    this.editCache[id] = {
      data: { ...this.overrideData[index] },
      edit: false
    };
  }

  updateEditCache(): void {
    this.overrideData.forEach(item => {
      this.editCache[item.overindex] = {
        edit: false,
        data: { ...item }
      };
    });
  }

  // Custom filter function that returns true for all items
  // This effectively disables the built-in filtering
  // This is used because it clashes with the new filter function
  customFilter = (input: string, option: any): boolean => {
    return true; // Show all options, let your search function handle filtering
  }

  searchTerm: string = "";

  filterStock(searchTerm: any){
    this.itemSize = 20;

    this.searchTerm = searchTerm;

    this.tempStockInfo = this.filterInfoStockArray();

    this.tempStockInfo = [...this.tempStockInfo];
    
  }

// Disables edit button if there are no changes to the current row
  duplicationCheck(item: StockData){
    if(JSON.stringify(item) === JSON.stringify(this.editCache[item.overindex].data))
      return true
    return false
  }

  loadMore(){
    const searchTerms = this.searchTerm.toLowerCase().split(' ').filter(term => term.length > 0);
    this.itemSize += 15;
    this.isLoading = true;
    this.isLoading = false;
    this.tempStockInfo = [...this.tempStockInfo, ...this.filterInfoStockArray().filter(item => !this.tempStockInfo.includes(item))];
  }

  getDateColor(dateString: string): string {
    const date = new Date(dateString);
    const now = new Date();
    
    const twoMonthsAgo = new Date();
    twoMonthsAgo.setMonth(now.getMonth() - 2);
    
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(now.getMonth() - 1);
    
    if (date <= twoMonthsAgo) {
      return '#a61d24';
    } else if (date <= oneMonthAgo) {
      return 'var(--warningcolor)';
    }
    
    return ''; // default color
  }

  getPopoverContext(value) {
    return {
      popoverData: {
        value: value
      }
    };
  }

  calculateRetailPrice(retailPrice: number): number {
    return (retailPrice - this.priceIn) / retailPrice;
  }

  calculateCost(cost: number): number {
    return 1 - (cost / this.priceIn);
  }

  calculateBranchCost(branchCost: number): number {
    return 1 - (branchCost / this.priceIn);
  }

  updateColumnMargins(){
    const filteredArray = this.overrideAddTable.map(obj => {
      const { ...rest } = obj;
      Object.keys(rest).forEach(key => {
        if (key === (this.priceType)) {
          obj[key] = this.marginType == 1 && obj.retail > 0 ? Math.round(obj.retail - (obj.retail * (this.overrideMargin/100))) :
                       this.marginType == 2 && obj.cost > 0 ? Math.round(obj.cost / (1 - (this.overrideMargin/100))) :
                       this.marginType == 3 && obj.branchCost > 0 ? Math.round(obj.branchCost / (1 - (this.overrideMargin/100))) : null;
        }
      });
      return rest;
    });
  }

  resetColumnMargins(){
    const filteredArray = this.overrideAddTable.map(obj => {
      const { ...rest } = obj;
      Object.keys(rest).forEach(key => {
        if (key === (this.priceType)) {
          obj[key] = null;
        }
      });
      return rest;
    });
  }

  filterInfoStockArray(): StockInfo[] {
    const searchTerms = this.searchTerm.toLowerCase().split(' ').filter(term => term.length > 0);
    let allStock : StockInfo [] = [];

    if(this.showNonActiveStock == true){
      allStock = this.stockInfo.filter(val => val.stockType === "TYRE"); //filter out all custom stock items
    }
    else{
      allStock = this.stockInfo.filter(val => val.activeId !== 0).filter(val => val.stockType === "TYRE"); //filter out all custom stock items
    }

    return allStock.filter(item => {
      // const itemDescription = item.descriptionFull.toLowerCase();
      return searchTerms.every(term => item.description.toLowerCase().includes(term) || item.gencode.toLowerCase().includes(term) || item.brand.toLowerCase().includes(term) || item.stockcode.toLowerCase().includes(term));
    }).slice(0,this.itemSize);
  }

}
